<div class="flex-layout space-inbetween header-main-info">
    <!-- Top left content section-->
    <div class="flex-layout column no-gap" style="width: 55%">
        <div class="order-detail-page-title">
          <span>{{orderShipment.customerName}}</span>
          <span class="customer-number" [copyable]="orderShipment.customerNumber" copyLabel="customer number">({{orderShipment.customerNumber}})</span>
          @if (orderShipment.orderSourceSystem === dynamicsSourceSystem) {
            <mat-icon class="small-icon" title="Dynamics" aria-hidden="true">verified</mat-icon>
          }
        </div>
        <div class="order-shipment-number"><span [copyable]="orderShipment.orderNumber" copyLabel="order number">Order #{{orderShipment.orderNumber}}</span> <span [copyable]="orderShipment.shipmentNumber" copyLabel="shipment number">Shipment #{{orderShipment.shipmentNumber}}</span></div>
        <span class="flex-layout order-dates">
            <span>
              <strong>Ships: </strong>
              <span [ngClass]="{ 'past-due': isShipmentPastDue() && !orderUtilityService.isOrderShipmentComplete(orderShipment) }">
                  {{orderShipment.shipDate | date:'MM-dd-y'}}
              </span> 
            </span>
            <span><strong>Need:</strong> {{orderShipment.needDate | date:'MM-dd-y'}}</span>
            <span><strong>Ordered:</strong> {{orderShipment.orderEntryDate | date:'MM-dd-y'}}</span>
        </span>
    </div>

    <div class="flex-layout column no-gap" style="align-items: flex-end">
        <div class="flex-layout">
            <!-- delivery type-->
            {{orderUtilityService.mapOrderMediaType(orderShipment.mediaType)}}

            <!-- delivery type icon-->
            <div class="media-icons">
                @if (orderUtilityService.mapOrderMediaType(orderShipment.mediaType) === 'CVD') {
                    <mat-icon matTooltip="CVD">album</mat-icon>
                }

                @if (orderUtilityService.mapOrderMediaType(orderShipment.mediaType) === 'Hard Drive') {
                    <mat-icon matTooltip="Hard Drive">usb</mat-icon>
                }

                @if (orderUtilityService.mapOrderMediaType(orderShipment.mediaType) === 'Electronic') {
                    <mat-icon matTooltip="Electronic">cloud_download</mat-icon>
                }
                <!-- order in dev to test this.... 4001769 -->
                @if (orderShipment.uploadShipmentToNetworkShare) {
                    <div class="pointer icon-tooltip" #scheduleTooltipOrigin="cdkOverlayOrigin" cdkOverlayOrigin>
                        <mat-icon>info</mat-icon>
                    </div>
                    <insight-popup-tooltip [overlayOrigin]="scheduleTooltipOrigin">
                        <ng-template>
                            Files are burnt through a network share with an uploading process.<br />
                            <a target="_blank" href="http://edelivery.swankmp.local/EdeliveryAdmin/Account/Details?arcCustomerNumber={{orderShipment.customerNumber}}">See the doc root folder location</a> where these file(s) will upload to.
                        </ng-template>
                    </insight-popup-tooltip>
                }
            </div>

            <!-- HD icon-->
            @if (isTheOrderInHD()) {
                <span class="hd-indicator">HD</span>
            }

            <!-- ADEBS, Streaming, or Cinelink with colored background -->
            <div [class]="getOrderTypeClass()">{{ getOrderTypeName() }}</div>
        </div>

        <!-- no need to show address if the order is being fulfilled electronically -->
         @if (orderUtilityService.mapOrderMediaType(orderShipment.mediaType) !== 'Electronic') {
            <div class="flex-layout no-gap text-end">
              {{shippingAddress}}
            </div>
         }
    </div>    
</div>

<!-- progress steps for content type -->
<insight-order-shipment-details-progress [orderShipment]="orderShipment"></insight-order-shipment-details-progress>

 <!-- miscellaneous data that will all just wrap -->
<div class="flex-layout customer-detail-container">
    <div class="customer-detail">
      <strong>Market:</strong>
      <span>{{ orderUtilityService.getMarketName(orderShipment.marketOrgType, false) }}</span>
    </div>

    @if (orderShipment.drmType) {
      <div class="customer-detail">
        <strong title="Field is from the DIG customer profile...not anything associated with the current order">DRM Type:</strong> 
        <span> {{orderShipment.drmType}}</span>
      </div>
    }

    <!-- no need to show the stream property for Cinelink or Streaming since there is only one -->
     @if (isAdebsOrder()) {
      <div class="customer-detail">
        <strong>Stream:</strong>
        <span>{{orderShipment.stream}}</span>
      </div>
    }    

    <div class="customer-detail">
      <strong>Account Exec:</strong>
      <span>{{orderShipment.accountExecutive}}</span>
    </div>

    <!-- only show entry user for orders submitted through Dynamics -->
    @if (orderShipment.entryUserName && orderShipment.orderSourceSystem === dynamicsSourceSystem) {
      <div class="customer-detail">
        <strong>Entry User:</strong>
        <span>{{ orderShipment.entryUserName }}</span>
      </div>
    }

    @if (shipmentRequiresSchedule()) {
      <div class="customer-detail">
        <strong>Schedule:</strong>            
          @if (orderShipment.isScheduleCompleted) {
            <span>Complete</span>
          } @else {
            <div class="warning-label" #scheduleTooltipOrigin="cdkOverlayOrigin" cdkOverlayOrigin>              
                <span>Incomplete</span>

                <span>
                  <mat-icon>warning</mat-icon>
                </span>

                <insight-popup-tooltip [overlayOrigin]="scheduleTooltipOrigin">
                  <ng-template>
                    <!-- The schedule is not done. Show slightly different messages depending on if someone as at least started it -->
                    @if (orderShipment.isScheduleCreatedInDatabase) {
                      <div class="flex-layout column">
                        <div>A schedule has been started, but not marked as complete.</div>
                        <a matButton="filled" color="primary" target="_blank" href="{{contentSchedulerBaseLink}}schedule-listing?search={{orderShipment.orderNumber}}">See schedule</a>
                      </div>
                    } @else {
                      <div class="flex-layout column">
                        <div>This order cannot ship until a schedule is created and marked complete.</div>
                        <div>This is done with the Content Scheduler tool.</div>
                        <a matButton="filled" color="primary" target="_blank" href="{{contentSchedulerBaseLink}}">Create schedule</a>
                      </div>
                    }
                  </ng-template>
                </insight-popup-tooltip>
            </div>
          }
      </div>
    }

   @if (orderShipment.manufacturingProfileId) {
      <div class="customer-detail">
        <strong>Mfg. Profile:</strong>        
        <a target="_blank" href="{{customerProfileLink}}"><span>{{orderShipment.manufacturingProfileId}}</span></a>        
        <span> ({{orderShipment.manufacturingProfileDescription}})</span>
      </div>
    }

    <div class="customer-detail">
      <strong>Cus. Profile:</strong>
      @if (orderShipment.manufacturingProfileId) {        
        <a target="_blank" href="{{manufacturingProfileLink}}"><span>{{orderShipment.digitalProfileDescription?.trim()}}</span></a>
        <span> ({{orderShipment.digitalSequenceNumber}})</span>   
      }

      @if (orderShipment.manufacturingProfileId === null || orderShipment.manufacturingProfileId === 0) {
        <div class="warning-label">
          <span>{{orderShipment.digitalProfileDescription}} ({{orderShipment.digitalSequenceNumber}})</span>
          <mat-icon title="Could not find a manufacturing profile with this name">report_problem</mat-icon>
        </div> 
      }
    </div>

    <!-- order details for ADEBS hard drives-->
    @if (isAdebsOrder()) {
      <div class="customer-detail">
        <strong>Burner:</strong>
        <span>{{orderShipment.burnStation ? orderShipment.burnStation : "None"}}</span>
      </div>
    }

    <!-- SGC burner related information. ADEBs orders will not have this field-->
    @if (orderShipment.sgcFulfillmentDetails !== null && orderShipment.sgcFulfillmentDetails.burner !== null ) {
      <div class="customer-detail burner-info">
        <strong>Burner:</strong>
        <span>{{orderShipment.sgcFulfillmentDetails.burner}}</span>
        <!-- put extra burner status information in a tooltip -->
        <!-- in dev, this order has a current status set for testing...1521464-->
        <div [hidden]="orderShipment.sgcFulfillmentDetails.currentStatus === null || isOrderComplete(orderShipment)"
            class="icon-tooltip pointer" #scheduleTooltipOrigin="cdkOverlayOrigin" cdkOverlayOrigin>
            <mat-icon>info</mat-icon>
        </div>
        <insight-popup-tooltip [overlayOrigin]="scheduleTooltipOrigin">
          <ng-template>
            <p class="no-margin">Current Status: {{ orderShipment.sgcFulfillmentDetails.currentStatus  }}  ( {{ orderShipment.sgcFulfillmentDetails.currentStatusDate | date:'short' }} )</p>
          </ng-template>
        </insight-popup-tooltip>
      </div>
    }

    @if (orderShipment.trackingCodeInfo) {
      <div class="customer-detail">
        <strong>Tracking Number:</strong>
        <a target="_blank" href="{{orderShipment.trackingCodeInfo.outgoingTrackingCode | trackingNumber}}">
          {{orderShipment.trackingCodeInfo.outgoingTrackingCode}}
        </a>
      </div>
    }

    @if (orderShipment.portalInformation) {
      <div class="customer-detail">
        <!-- Show extra portal information for streaming server orders -->
        <div class="tooltip-button pointer" #overlayOrigin="cdkOverlayOrigin" cdkOverlayOrigin>
            Portal Info
        </div>
        <insight-popup-tooltip [overlayOrigin]="overlayOrigin">
          <ng-template>
            <div class="portal-info-container">
              @for (portal of orderShipment.portalInformation; track portal) {
                <div>
                  <strong>{{portal.portalName}}</strong> ({{portal.onDemandServer}}) -
                  <a target="_blank" href="{{trackerBaseLink}}streaming-details/details/{{portal.portalId}}">{{ portal.portalId }}</a>
                </div>
              }
              @if (orderShipment.portalInformation.length === 0) {
                <div class="warning-label">
                  <mat-icon>warning</mat-icon>
                  <span>No portal information found.</span>
                </div>
              }
            </div>
          </ng-template>
        </insight-popup-tooltip>
      </div>
    }

    @if (orderShipment.cinelinkBoxIds) {
      <div class="customer-detail">
        <div class="tooltip-button pointer" #overlayOrigin="cdkOverlayOrigin" cdkOverlayOrigin>
            Cinelink box information
        </div>

        <insight-popup-tooltip [overlayOrigin]="overlayOrigin" [noPadding]="true">
          <ng-template>
            <div class="tooltip-title">
              @if (orderShipment.cinelinkBoxIds.length > 1) {
                <span>Showing first {{orderShipment.cinelinkBoxIds.length}} boxes:</span>
              } @else {
                <span>Cinelink box:</span>
              }
            </div>

            <div class="cinelink-boxes-container">
              <div class="cinelink-boxes">
                @if (orderShipment.cinelinkBoxIds.length > 0) {
                  @for (box of orderShipment.cinelinkBoxIds; track box) {
                    <a href="{{trackerBaseLink}}cinelink-details/machine/{{box}}" target="_blank">{{box}}</a>
                  }
                } @else {
                  <div class="warning-label">
                    <mat-icon>warning</mat-icon>
                    <span>No Cinelink boxes associated with order found.</span>
                  </div>
                }
              </div>

              <a matButton="filled" color="primary" href="{{trackerBaseLink}}products?search={{orderShipment.customerNumber}}&cinelink=true" target="_blank">See all Cinelink devices associated with this customer</a>
            </div>
          </ng-template>
        </insight-popup-tooltip>
      </div>
    }

    <!-- we don't bring back license data for ADEBS orders currently -->
    @if (!isAdebsOrder() && orderUtilityService.isAllLicensesSameDateRange(orderShipment.lines)) {
      <div class="customer-detail">
        <strong>License Window:</strong>
        <span>{{ getCommonLicenseDateRange() }}</span>
      </div>
    }
</div>
